import { makeStyles, createStyles, Theme } from '@material-ui/core'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    takeBackAndRentalOrderList: {
      marginTop: theme.spacing(4),
    },
    orderListTitle: {
      marginBottom: theme.spacing(2),
    },
    orderHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    circleDefault: {
      width: 16,
      height: 16,
      borderRadius: '50%',
      backgroundColor: theme.palette.common.black,
    },
    circlePrimary: {
      backgroundColor: theme.palette.primary.main,
    },
    circleSecondary: {
      backgroundColor: theme.palette.secondary.main,
    },
    circleWarning: {
      backgroundColor: theme.palette.warning.main,
    },
    orderTitle: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      paddingLeft: theme.spacing(1),
    },
    orderItem: {
      borderLeft: `1px solid currentColor`,
      paddingLeft: theme.spacing(2),
      marginLeft: theme.spacing(1),
      paddingBottom: theme.spacing(3),
    },
    orderItemComing: {
      borderLeft: `1px dashed ${theme.extraColors.greyMedium}`,
    },
    orderItemReturn: {
      borderLeft: `1px solid ${theme.palette.secondary.main}`,
    },
    orderItemCancelled: {
      borderLeft: `1px dashed ${theme.palette.warning.main}`,
    },
    orderItemLast: {
      border: 0,
    },
    productCard: {
      background: theme.palette.common.white,
      borderRadius: theme.shape.borderRadius,
      minHeight: 60,
      padding: theme.spacing(1),
      display: 'flex',
      alignItems: 'center',
      marginBottom: theme.spacing(2),
      [theme.breakpoints.down('md')]: {
        width: '100%',
      },
    },
    imgProduct: {
      width: 50,
      height: 50,
      objectFit: 'contain',
      display: 'block',
    },
    imgContainer: {
      width: 50,
      marginLeft: theme.spacing(2),
      [theme.breakpoints.down('md')]: {
        marginLeft: theme.spacing(0),
      },
    },
    productName: {
      marginLeft: theme.spacing(2),
      [theme.breakpoints.down('md')]: {
        marginLeft: theme.spacing(1),
      },
    },
    productReturned: {
      display: 'inline-block',
      textTransform: 'uppercase',
      fontSize: 11,
      color: theme.palette.common.white,
      backgroundColor: theme.extraColors.greyMedium,
      padding: theme.spacing(0, 0.25),
    },
    downloadInvoiceButton: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
    warning: {
      color: theme.palette.warning.main,
    },
    buyArea: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    cancelArea: {
      textAlign: 'right',
      paddingBottom: '0.3rem',
    },
    cancelBtn: {
      padding: 0,
      textTransform: 'none',
      textDecoration: 'underline',
      fontSize: '80%',
      color: theme.extraColors.greyText,
      '&:hover, &:focus': {
        background: 'none',
      },
    },
    modal: {
      borderRadius: 0,
      '& .MuiPaper-root': {
        borderRadius: 0,
        [theme.breakpoints.up('md')]: {
          minWidth: 700,
        },
      },
    },
    modalHead: {
      padding: theme.spacing(2, 3),
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      background: theme.extraColors.greyLight,
      '& .MuiTypography-root': {
        fontWeight: 400,
        lineHeight: 1,
      },
    },
    modalHeadWarning: {
      display: 'inline-flex',
      alignItems: 'center',
      color: theme.palette.error.main,
      '&>.MuiSvgIcon-root': {
        marginRight: theme.spacing(1),
      },
    },
    modalFoot: {
      padding: theme.spacing(1, 2),
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
    },
    modalContent: {
      padding: theme.spacing(3),
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: theme.spacing(1),
    },
    modalClose: {
      cursor: 'pointer',
      padding: theme.spacing(0.5),
      width: theme.spacing(4),
      height: theme.spacing(4),
      borderRadius: theme.spacing(2),
      textAlign: 'center',
      color: theme.extraColors.greyLight,
      background: theme.extraColors.greyMedium,
      '&:hover, &:focus': {
        background: theme.palette.common.black,
      },
    },
    cancelCTA: {
      // color: theme.palette.error.main,
      // borderColor: theme.palette.error.main,
    },
    //second hand order list style
    root: {},
    hide: {
      opacity: 0,
      transition: theme.transitions.create('opacity'),
    },
    show: {
      opacity: 1,
      transition: theme.transitions.create('opacity'),
    },
    takeBackListTitle: {
      marginBottom: theme.spacing(2),
    },
    takeBackListHeader: {
      display: 'flex',
      justifyContent: 'start',
      alignItems: 'center',
    },
    takeBackItemTitle: {
      paddingLeft: theme.spacing(1),
    },
    circle: {
      width: 16,
      height: 16,
      borderRadius: '50%',
      backgroundColor: theme.palette.primary.main,
    },
    productCardCheckbox: {},
    productCardImg: {
      width: 50,
      height: 50,
      position: 'relative',
      marginRight: theme.spacing(2),
      [theme.breakpoints.down('md')]: {
        marginRight: theme.spacing(1),
      },
    },
    productCardContent: {
      flex: 1,
    },
    takeBackItem: {
      borderLeft: `1px solid currentColor`,
      paddingLeft: theme.spacing(2),
      marginLeft: theme.spacing(1),
      paddingBottom: theme.spacing(3),
    },
    takeBackItemActive: {
      borderColor: 'transparent',
      paddingLeft: 0,
      marginLeft: theme.spacing(1),
    },
    takeBackItemLast: {
      borderLeft: 0,
    },
    productStatus: {
      marginLeft: theme.spacing(2),
      [theme.breakpoints.down('md')]: {
        marginLeft: theme.spacing(1),
      },
    },
    takeBackOrder: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: theme.spacing(2),
      width: '100%',
    },
    orderDetailsRow: {
      textAlign: 'right',
    },
    orderDetailsBtn: {},
    orderDetailsRowActions: {
      padding: theme.spacing(1, 0, 2),
    },
    simpleButton: {
      padding: 0,
      textTransform: 'inherit',
      color: theme.extraColors.greyText,
      '&:hover, &:focus': {
        background: 'none',
      },
      '& .MuiSvgIcon-root': {
        fontSize: '.8rem',
      },
    },
    simpleButtonPrimary: {
      color: theme.palette.primary.main,
    },
    simpleButtonDanger: {
      color: theme.palette.error.main,
    },
    currentOrderList: {
      padding: theme.spacing(3),
      background: theme.palette.common.white,
    },
    loaderContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '20vh',
    },
    returnCtaContainer: {
      minHeight: '2rem',
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    orderContent: {
      margin: theme.spacing(2, 0),
    },
    OrderTitle: {
      marginBottom: theme.spacing(1),
    },
  })
)

export default useStyles
